import { Sidebar } from "primereact/sidebar";
import { useContext } from "react";
import { LayoutContext } from "./context/layoutcontext";
import { AuthenticatorContext } from "../contexts/AuthenticatorContext";
import { useTranslation } from "react-i18next";

const AppProfileSidebar = () => {
    const { t } = useTranslation();
    const { signOut, userInfo } = useContext(AuthenticatorContext);
    const { layoutState, setLayoutState } = useContext(LayoutContext);
    const username = `${userInfo.name} ${userInfo.family_name}`;

    const onProfileSidebarHide = () => {
        setLayoutState((prevState) => ({ ...prevState, profileSidebarVisible: false }));
    };

    const onConfigButtonClick = () => {
        setLayoutState((prevState) => ({ ...prevState, configSidebarVisible: true }));
    };

    return (
        <Sidebar visible={layoutState.profileSidebarVisible} onHide={onProfileSidebarHide} position="right" className="layout-profile-sidebar w-full sm:w-25rem">
            <div className="flex flex-column mx-auto md:mx-0">
                <span className="mb-2 font-semibold">
                    {t("profileSideBar.welcome")}
                </span>
                <span className="text-color-secondary font-medium mb-5">
                    {username}
                </span>

                <ul className="list-none m-0 p-0">
                    <li>
                        <a className="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150" onClick={onConfigButtonClick}>
                            <span className="flex align-items-center">
                                <i className="pi pi-cog text-xl text-primary" />
                            </span>
                            <div className="ml-3">
                                <span className="font-semibold">
                                    {t("profileSideBar.visualSettings")}
                                </span>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a onClick={signOut} className="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                            <span className="flex align-items-center">
                                <i className="pi pi-power-off text-xl text-primary" />
                            </span>
                            <div className="ml-3">
                                <span className="font-semibold">
                                    {t("profileSideBar.signOut")}
                                </span>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </Sidebar>
    );
};

export default AppProfileSidebar;
